/**
 *@author shaolei
 *@date 2020/04/17
 *@file_name:list
 *@Description:已订阅管理
 */
<template>
  <div class="list">
    <div class="title">
      <div class="_p">已订阅列表</div>
      <div @click="toLink('/control/newApplication')" class="apply">新增订阅</div>
    </div>
    <div v-show="isAuth == 1">
      <div class="basic-info">
        <table class="pure-table pure-table-bordered" width="100%" border="0" cellspacing="0" cellpadding="0">
            <thead>
              <tr><th>基本信息</th><th></th><th></th></tr>  
            </thead>
            <tbody>
              <tr><td rowspan="2" style="width:20%">生产环境</td><td style="width:20%">APPKEY：</td><td>{{basicInfo.proKey}}</td></tr>
              <tr><td style="width:20%">APPSECRET：</td>
              <td>
                <div class="copy">{{ basicInfo.proSecret}}
                  <el-tooltip class="item" effect="dark" content="点击复制" placement="right">
                    <i class="el-icon-document-copy icon_place" @click="doCopy(basicInfo.proSecret)"></i>
                  </el-tooltip>               
                </div>
              </td></tr>
              <tr><td rowspan="2" style="width:20%">测试环境</td><td style="width:20%">APPKEY：</td><td>{{basicInfo.uatKey}}</td></tr>
              <tr><td style="width:20%">APPSECRET：</td>
              <td>
                <div class="copy">{{ basicInfo.uatSecret}}
                  <el-tooltip class="item" effect="dark" content="点击复制" placement="right">
                    <i class="el-icon-document-copy icon_place" @click="doCopy(basicInfo.uatSecret)"></i>
                  </el-tooltip>               
                </div> 
              </td></tr>  
            </tbody>
        </table>     
      </div>
      <div class="api_list">
        <div class="table">
          <div class="table_title">订阅列表</div>
          <el-table :data="tableData" v-show="tableData.length" border="" style="width: 100%" size="mini">
            <el-table-column prop="apiName" header-align="center" align="left" label="API名称" width="150">
              <template slot-scope="scope">
              <el-link class="link" @click="toDetails(scope.row)" v-if="(scope.row.docId!=null || scope.row.docId!=0)&& scope.row.isLimitIp ==1">{{ scope.row.apiName }}</el-link>
              <span v-else-if="(scope.row.docId!=null || scope.row.docId!=0) && scope.row.isLimitIp !=1"  class="hasWhites" @click="toDetails(scope.row)">{{scope.row.apiName}}
                <el-tooltip class="item" effect="dark" content="该接口必须配置IP白名单" placement="top">
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </span>
              <span v-else>{{scope.row.apiName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="apiDesc" header-align="center" align="left" label="API说明"></el-table-column>
            <el-table-column prop="apiType" header-align="center" align="left" label="API类型" width="115"></el-table-column>
            <!-- <el-table-column prop="reqTotalCount" header-align="center" align="left" label="调用次数" width="96"></el-table-column>
            <el-table-column prop="succesCount" header-align="center" align="left" label="成功次数" width="96"></el-table-column>
            <el-table-column prop="failCount" header-align="center" align="left" label="失败次数" width="96"></el-table-column>
            <el-table-column width="95" header-align="center" align="left"  label="平均响应时间">
              <template slot-scope="scope">
                <div>{{ scope.row.avgRespTime }} ms</div>
              </template>
            </el-table-column> -->
            <el-table-column width="170" header-align="center" align="center" label="操作">
              <template slot-scope="scope">
                <div class="operating">
                  <el-button size="mini" @click="showDel(scope.row.apiCode)">取消订阅</el-button>
                  <el-button size="mini" @click="showedit(scope.row)">编辑</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div v-show="tableData.length" class="page">
            <el-pagination
              background=""
              @size-change="sizeChange"
              @current-change="currentChange"
              :current-page="page"
              :page-sizes="[10, 20, 30]"
              :page-size="pageSize"
              layout="sizes, prev, pager, next, jumper, total"
              :total="table_total"
            ></el-pagination>
          </div>
          <div v-show="!tableData.length" class="empy">
            <img src="@/assets/images/empy_api.png" alt="">
            <div v-show="isPass == 1">
              <div class="e">对不起，您尚未通过审核</div>
              <div class="m">您的企业信息正在审核中，请耐心等待！</div>
            </div>
            <div v-show="isPass == 2">
              <div class="e">对不起，您尚未订阅API</div>
              <div class="m">
                点击右上侧
                <span>"新增订阅"</span>按钮，进行订阅
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 未认证 -->
    <div v-show="isAuth == 0" class="noAuth">
      <img src="@/assets/images/console-empty.png" alt="">
      <div class="e">请先进行企业认证</div>
      <div @click="toLink('/account/company')" class="btn">立即认证</div>
    </div>
    <Verify
      @success="success"
      :mode="'pop'"
      :captchaType="'blockPuzzle'"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="verify"
      v-if="isVerify"
    ></Verify>
    <el-dialog
      :title="selfconfig.title"
      :visible.sync="addipGroup"
      :before-close="handleClose"
      :close-on-click-modal = false
      width="570px"
      center>
      <div class="diaBody">
       <ul class="diatop">
         <li><p class="left">API名称</p><p class="right">{{digdata.apiName}}</p></li>
         <li><p class="left">API类型</p><p class="right">{{digdata.apiType}}</p></li>
         <li><p class="left">API说明</p><p class="right">{{digdata.apiDesc}}</p></li>
       </ul>
       <div class="digbottom">
         <div class="b_left">指定IP</div>
          <div class="b_right">
            <el-form :model="addForm" size="small" ref="dtform">
              <el-form-item prop="one" :rules="selfconfig.isLimitIp == 1 ? ruleForm.one : ruleForm.oneIP">
                <el-input placeholder="限定只有此ip可调用" v-model="addForm.one"></el-input>
              </el-form-item>
              <div class="moreRules">
                <div class="moreRulesIn" v-for="(item,index) in addForm.moreInput" :key="index">
                  <el-form-item :prop="'moreInput.' + index +'.value'" :rules="selfconfig.isLimitIp == 1 ? selfrule.Ipruleone : selfrule.IpruleoneIP">
                    <el-input placeholder="限定只有此ip可调用" v-model="item.value"></el-input>
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>
         <div class="b_btns">
           <p @click="addinput"><i class="el-icon-plus"></i></p>
           <p @click="removeinput"><i class="el-icon-minus"></i></p>
         </div>
       </div>
      </div>
      <div style="color:#f56c6c;padding-left:60px">*或空表示不限制ip</div>
      <span slot="footer" class="dialog-footer">
        <button @click="editto" class="selfbtn">确 定</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Verify from "@/components/verifition/Verify";
import {
  getBaisc,
  getSubscription,
  delApis,
  getMessageCode,
  editip,
  changeIp,
  changeIsip,
  notempty
} from "@/apis/console.js";
import { _delApis } from "@/validate/rules";
export default {
  name: "list",
  data() {
    return {
      isVerify: true,
      captcha:'',
      table_total: 0,
      pageSize: 10,
      page: 1,
      tableData: [],
      basicInfo: {
        proKey:'',
        proSecret:'',
        uatKey:'',
        uatSecret:'',
      },
      isAuth: -1,
      isPass: -1, // 审核还未通过
      isDel: false,
      second: 60,
      code_text: "发送验证码",
      sendMsgDisabled: true,
      picutureCode: "", //短信验证码
      del_id: "",
      codeForm: {
        phoneCode: ""
      },
      rules: _delApis,
      addipGroup:false,  //新增ip组弹窗
      digdata:{},  //弹窗数据
      selfconfig:{title:'',type:0,isLimitIp:0},
      addForm:{
        one:'',
        moreInput:[{
          value:""
        }]
      },
      ruleForm: {
        one: [{ required: false, validator: changeIp, trigger: "blur" }],
        oneIP: [{ required: false, validator: changeIsip, trigger: "blur" }],
      },
      selfrule: {
        Ipruleone: [{ required: false, validator: changeIp, trigger: "blur" }],
        IpruleoneIP: [{ required: false, validator: changeIsip, trigger: "blur" }],
      },
    };
  },

  components: {
    //组件声明
    Verify
  },

  computed: {
    //计算属性
  },

  created() {
    //创建时执行
    this.getBaisc();
    this.getSubscription();
    this.addForm.moreInput = [];
  },

  mounted() {
    //数据挂载
  },

  methods: {
    success(params) {
      this.captcha = params.captchaVerification; //滑动验证码
      this.isVerify = false; //行为验证成功
      this.del(this.captcha);
    },
    //函数声明
    getBaisc() {
      getBaisc(this).then(res => {
        if (res.success) {
          const data = res.data;
          this.basicInfo.proKey = data.prod.appKey;
          this.basicInfo.proSecret = data.prod.appSecret;
          this.basicInfo.uatKey = data.test.appKey;
          this.basicInfo.uatSecret = data.test.appSecret;
          this.isAuth = 1;
        } else {
          this.isAuth = 0;
        }
      });
    },

    /** 获取订阅列表 */
    getSubscription() {
      getSubscription(this).then(res => {
        if (res.success) {
          if (!res.data.items.length) {
            this.isPass = 2;
          }
          this.tableData = res.data.items;
          this.table_total = res.data.totalNum;
        } else {
          if (res.data.code == 40011 || res.data.code) {
            // 审核未通过该
            this.isPass = 1;
          } else {
            // 通过
            this.isPass = 2;
          }
        }
      });
    },

    /** 分页变化 */
    sizeChange(e) {
      this.pageSize = e;
      this.getSubscription();
    },
    /** 页面跳转 */
    currentChange(e) {
      this.page = e;
      this.getSubscription();     
    },
    /** 跳转 */
    toLink(path) {
      this.$router.push(path);
    },

    /** 获取短信验证码 */
    getCode() {
      let that = this;
      if (that.sendMsgDisabled) {
        getMessageCode(this).then(res => {
          that.sendMsgDisabled = false;
          this.$message.success("短信发送成功，请注意查收！");
        });
        that.timer = setInterval(() => {
          that.second--;
          if (that.second <= 0) {
            clearTimeout(that.timer);
            that.sendMsgDisabled = true;
            that.second = 60;
            this.code_text = "重新获取";
          }
        }, 1000);
      }
    },
    /** 展示删除 */
    showDel(id) {
      this.del_id = id;
      this.isVerify = true
      this.$nextTick(()=>{
        this.$refs.verify.show();
      })
    },
    /** 编辑 */
    showedit(data){
      this.selfconfig.title = '编辑API配置';
      this.selfconfig.type = 2;
      this.selfconfig.isLimitIp = data.isLimitIp 
      // data.isLimitIp == 1 ? this.addForm.one = "*" : this.addForm.one = "";
      this.addipGroup = true;
      let Ipgroup = data.limitIp.split(',');
      Ipgroup = notempty(Ipgroup);
      this.addForm.one = Ipgroup[0];
      let thidstart = Ipgroup.slice(1);
      this.addForm.moreInput = thidstart.map(item=>{
        return{
          value:item
        }
      })
      this.digdata.apiCode = data.apiCode;
      this.digdata.apiName = data.apiName;
      this.digdata.apiType = data.apiType;
      this.digdata.apiDesc = data.apiDesc;
    },
    //弹窗关闭
    handleClose(done) {
      done();
      this.$nextTick(()=>{
         this.$refs.dtform.resetFields();
      })
    },
    //编辑提交
    editto(){
      this.$refs.dtform.validate((valid) => {
        if (valid) { 
          let apiCode = this.digdata.apiCode;
          let limitIp = [this.addForm.one ? this.addForm.one : '*'];
          for(let i = 0,len = this.addForm.moreInput.length;i<len;i++){
            if(this.addForm.moreInput[i].value){
              limitIp.push(this.addForm.moreInput[i].value);
            }
          }
          limitIp = limitIp.join(",");
          editip(this, apiCode,limitIp).then(res => {
            if(res.success){
              this.addipGroup = false;
              this.$message.success('编辑成功!')
              this.getSubscription();
            }
          }); 
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /** 删除 */
    del(captcha) {
        const queryObj = {
           del_id:this.del_id,
           captcha
        }
        delApis(queryObj).then(res => {
          if (res.success) {
            this.$message.success('订阅取消成功!')
            this.getSubscription();
          }
        });
    },
    /** 动态添加input */
    addinput () {
      if(this.addForm.moreInput.length < 14){
         this.addForm.moreInput.push({value:''})   
      }else{
         return
      }  
    },
    removeinput(){
      if(this.addForm.moreInput.length <= 0){
        return
      }else{
        this.addForm.moreInput.pop({value:''})
      }
    },
    /** 跳转详情 */
    toDetails(query) {
      let newpage = this.$router.resolve({
        path: "/api/apiDoc",
        query:{apiCode:query.apiCode}
      });
      window.open(newpage.href, "_blank");
    },
    /** 点击复制 */
    doCopy(msg){
      let that = this;
      this.$copyText(msg).then(function (e) {
        that.$message.success("内容已复制到剪切板!")
      }, function (e) {
        that.$message.error("内容复制失败!")
      })
    }
  }
};
</script>
<style lang='less' scoped>
.list {
  .title {
    position: relative;
    height: 64px;
    display: flex;
    align-items: center;

    .apply {
      position: absolute;
      -moz-user-select: none; /*火狐*/
      -webkit-user-select: none; /*webkit浏览器*/
      -ms-user-select: none; /*IE10*/
      -khtml-user-select: none; /*早期浏览器*/
      user-select: none;
      cursor: pointer;
      padding: 5px 22px;
      font-size: 14px;
      color: #333333;
      border-radius: 2px;
      right: 0;
      background: #fabe00;
    }

    &::after {
      content: "";
      position: absolute;
      height: 1px;
      left: 0px;
      right: 0px;
      bottom: 0;
      background: #ebebec;
    }

    ._p {
      font-size: 16px;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        width: 4px;
        left: -20px;
        top: 5px;
        bottom: 5px;
        background: #fabe00;
      }
    }
  }

  .basic-info {
    padding-top: 20px;
    .pure-table {
        border-collapse: collapse;
        border-spacing: 0;
        empty-cells: show;
        font-size: 14px;
        border: 1px solid #EBEEF5;
    }
    .pure-table caption {
        color: #000;
        font: italic 85%/1 arial,sans-serif;
        padding: 1em 0;
        text-align: center;
    }
    .pure-table td,.pure-table th {
        border-left: 1px solid #EBEEF5;
        border-width: 0 0 0 1px;
        font-size: inherit;
        margin: 0;
        overflow: visible;
        padding: .5em 1em;
    }
    .pure-table thead {
        background-color: #fafafa;
        color: #333333;
        text-align: left;
        vertical-align: bottom;
        border-bottom: 1px solid #EBEEF5;
    }
    
    .pure-table td {
        background-color: transparent;
    }
    .pure-table-bordered td {
        border-bottom: 1px solid #EBEEF5;
    }
    .pure-table-bordered tbody>tr:last-child>td {
        border-bottom-width: 0;
    }
    // .table {
    //   border: 1px solid #ebeae8;

    //   .table_title {
    //     padding: 10px 20px;
    //     background: #fafafa;
    //     font-size: 14px;
    //     color: #333333;
    //     font-weight: 500;
    //   }

    //   .tr {
    //     display: flex;
    //     font-size: 14px;
    //     color: #333333;
    //     .tdLeft{
    //       height: 80px;
    //       flex-basis: 150px;
    //       line-height: 80px;
    //       text-align: center;
    //       border-top: 1px solid #ebeae8;
    //     }
    //     .tdRight{
    //       height: 80px;
    //       border-top: 1px solid #ebeae8;
    //     }
    //     .td {
    //       padding: 10px 20px;
    //       border-top: 1px solid #ebeae8;
    //     }

    //     :first-child {
    //       flex-basis: 150px;
    //       border-right: 1px solid #ebeae8;
    //     }
    //     :last-child {
    //       flex: 1;
    //     }
    //   }
    // }
  }

  .api_list {
    margin-top: 20px;

    .table {
      .table_title {
        padding: 10px 20px;
        background: #fafafa;
        font-size: 14px;
        color: #333333;
        font-weight: 600;
        border: 1px solid #ebeae8;
        border-bottom: none;
      }
      /deep/thead > tr > th {
        background: #fafafa;
        color: #333333;
        font-weight: normal;
        height: 60px;
        padding: 0;
      }

      .status {
        position: relative;
        padding-left: 15px;

        &::after {
          position: absolute;
          content: "";
          width: 6px;
          height: 6px;
          border-radius: 100%;
          background: #75bd65;
          left: 0;
          top: 50%;
          margin-top: -3px;
          z-index: 9;
        }
      }

      .offline {
        &::after {
          background: #ff6f6f;
        }
      }

      .operating {
        display: flex;
        justify-content: space-between;

        .btn {
          font-size: 14px;
          color: #8095da;
          cursor: pointer;
        }

        .del {
          color: #f49b98;
        }
      }
      .page {
        padding: 25px 0;
        display: flex;
        justify-content: flex-end;

        /deep/.el-pagination__total {
          line-height: 30px;
          padding-left: 15px;
        }

        /deep/.el-pager {
          /deep/li {
            background: #fff;
            border: 1px solid #ebebec;
            line-height: 28px;
            font-weight: normal;
          }
          /deep/.active {
            background: #fabe00;
            border-color: #fabe00;
          }
        }
        /deep/.btn-prev,
        /deep/.btn-next {
          background: #fff;
          border: 1px solid #ebebec;
        }
      }

      .link {
        cursor: pointer;
        color: #409eff;
      }
    }
    .empy {
      min-height: 50vh;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border: 1px solid #ebeae8;

      img {
        width: 163.39px;
        height: 133.53px;
      }

      .e {
        color: #666666;
        font-size: 16px;
        padding: 10px 0;
        text-align: center;
      }

      .m {
        font-size: 12px;
        color: #999999;

        span {
          color: #fabe00;
        }
      }
    }
  }
  .noAuth {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-top: 240px;

    img {
      width: 163.5px;
      height: 142.4px;
    }

    .e {
      color: #666666;
      font-size: 16px;
      padding: 10px 0;
    }

    .btn {
      margin: 20px;
      width: 164px;
      height: 34px;
      border: 1px solid rgba(250, 190, 0, 1);
      box-shadow: 0px 3px 12px rgba(250, 190, 0, 0.5);
      border-radius: 2px;
      cursor: pointer;
      color: #fabe00;
      font-size: 14px;
      line-height: 34px;
      text-align: center;
    }
  }

  ._del {
    /deep/.el-dialog__header {
      padding: 35px;
      box-sizing: border-box;

      /deep/.el-dialog__title {
        font-size: 16px;
        font-weight: normal;
        color: #333333;
      }
    }

    /deep/.el-dialog__body {
      padding: 20px 42px;
    }

    .content {
      .code {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .input {
          width: 173px;
        }

        .getCode {
          width: 80px;
          height: 30px;
          background: rgba(250, 190, 0, 0.1);
          border: 1px solid rgba(250, 190, 0, 1);
          opacity: 1;
          border-radius: 2px;
          color: #fabe00;
          font-size: 12px;
          line-height: 30px;
          text-align: center;
          cursor: pointer;
          position: absolute;
          right: -85px;
          top: 4px;
        }

        .sendCode {
          background: rgba(247, 246, 245, 1);
          pointer-events: none;
          cursor: default;
          color: #d7d7d7;
          border: 1px solid #d7d7d7;
        }
      }

      .btn {
        margin-top: 40px;
        margin-bottom: 30px;
        width: 262px;
        height: 34px;
        background: rgba(250, 190, 0, 1);
        border-radius: 2px;
        line-height: 34px;
        color: #333333;
        font-size: 14px;
        cursor: pointer;
        text-align: center;
      }
    }
  }
}
.diaBody{
  display: flex;
  flex-direction: column;
  .diatop{
    height: 102px;
    li{
      display: flex;
      justify-content: flex-start;
      line-height: 32px;
      height: 32px;
      .left{
        width: 160px;
        box-sizing: border-box;
        padding-left: 60px;
        text-align: left;
      }
      .right{flex:1}
    }
  } 
  .digbottom{
    flex: 1;
    position: relative;
    .b_left{
      width: 160px;
      box-sizing: border-box;
      float: left;
      padding-left: 60px;
      height: 100%;
    }
    .b_right{
      width: 260px;
      float: left;
      .checkInput{
       .errortip{
         height: 14px;
         line-height: 14px;
         font-size: 12px;
         color: red; 
       } 
      }
    }
    .b_btns{
      position: absolute;
      right: 32px;
      width: 60px;
      height: 100%;
      top:2px;
      // padding-bottom:23px;
      box-sizing: border-box;
      display: flex;
      // flex-direction: column;
      justify-content: space-between;
      p{
        width: 25px;
        height: 25px;
        line-height: 25px;
        background: #fabe00;
        text-align: center;
        border-radius: 4px;
      }
    }
    .ipInput{
      width: 250px;
    }
  } 

}
.selfbtn{
    width: 200px;
    color: #FFFFFF;
    height: 30px;
    background: rgba(250, 190, 0, 1);
    border: 1px solid rgba(250, 190, 0, 1);
    box-shadow: 0px 3px 12px rgba(250, 190, 0, 0.5);
    border-radius: 4px;
    font-size: 14px;
}
.copy{
    width: 200px;
    padding-right: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    border-right: none !important;
    .icon_place{
      position: absolute;
      top: 6px;
      left: 201px;
      cursor: pointer;
    }
}
.hasWhites{
  color:#F56C6C;
  font-size: 14px;
  cursor: pointer;
  &:hover{
    text-decoration: underline;
  }
}
</style>
